import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useExport from "../../hooks/useExport";
import ImageIcon from "./ImageIcon";
import ExportIcon from "../../assets/icons/ExportIcon";
import { useDebounce } from "../../hooks/useDebounce";
import { Tooltip } from "react-tooltip";
type Props = {
  getFunction: any;
  getFunctionParams: any;
  fileName: string;
  dataKey?: string;
  excludedColumns?: string[] | undefined;
};

function ExportButton({
  getFunction,
  getFunctionParams,
  fileName,
  dataKey,
  excludedColumns,
}: Props) {
  const { generateExcelFile } = useExport();

  const [startExporting, setStartExporting] = useState(false);

  const preparedParams =
    getFunctionParams &&
    typeof getFunctionParams === "object" &&
    !Array.isArray(getFunctionParams)
      ? {
          ...getFunctionParams,
        }
      : getFunctionParams;
  const { data, isLoading, isFetching, isUninitialized, refetch, isSuccess } =
    getFunction(preparedParams, {
      skip: !startExporting,
    });

  useEffect(() => {
    console.log(data);

    if (isSuccess && data && !isFetching && !isLoading && startExporting) {
      if (!data || !data?.data || data?.data?.length === 0) {
        toast.error("No data to export");
      } else {
        generateExcelFile(
          dataKey ? [...data?.data[dataKey]] : [...data?.data],
          `${fileName}`,
          { limitFields: excludedColumns },
        );
        toast.success("Exported successfully");
      }
      setStartExporting(false);
    }
  }, [isSuccess, data, isLoading, isFetching, startExporting]);
  return (
    <>
     <Tooltip
                id="export-tooltip"
                style={{
                  backgroundColor: "#ccc",
                  color: "#1e1850",
                  fontWeight: "bold",
                  
                  top: "0px",
                  zIndex: 1000,
                }}
                place="top"
              />
    <button
      data-tooltip-id="export-tooltip"
      data-tooltip-content="Export"
      className="flex gap-2 items-center  dark:bg-primaryLight p-2 rounded-2xl border border-[#6666665C]"
      onClick={() => {
        if (!isLoading && !isFetching && !isUninitialized) {
          if (data) {
            refetch();
          } else {
            setStartExporting(true);
          }
        } else {
          setStartExporting(true);
        }
      }}
    >
      {isLoading || isFetching ? (
        <span className="loaderReport export"></span>
      ) : (
        <ImageIcon
          Icon={ExportIcon}
          width={22}
          height={22}
          className="min-w-[32px]"
        />
      )}
    </button>
    </>
   
  );
}

export default ExportButton;
